/** Human-readable browser name for GPU guidance copy (`Chrome settings`, etc.). */
export function getBrowserDisplayName(): string {
    if (typeof navigator === "undefined") {
        return "browser";
    }
    const ua = navigator.userAgent;
    if (/Edg\//.test(ua)) {
        return "Edge";
    }
    if (/Chrome\//.test(ua) || /CriOS\//.test(ua)) {
        return "Chrome";
    }
    if (/Firefox\//.test(ua) || /FxiOS\//.test(ua)) {
        return "Firefox";
    }
    if (/Safari\//.test(ua)) {
        return "Safari";
    }
    return "browser";
}
